import React from "react";
import AppButton from "@common/components/app-button";
import {ReactComponent as EyeSlashIcon} from "@assets/icons/eye-slash.svg";

interface VisibilitySectionProps {
    isVisible: boolean;
    onToggle: () => void;
}

const VisibilitySection: React.FC<VisibilitySectionProps> = ({isVisible, onToggle}) => {
    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
                <h2 className="text-lg font-semibold text-on-surface">
                    Widoczność na stronie
                </h2>
                <p className="text-base text-on-surface/80 leading-5 font-normal">
                    Aplikacja jest{" "}
                    <span
                        className={`font-semibold ${isVisible ? "text-success" : "text-error"}`}
                    >
                        {isVisible ? "widoczna" : "niewidoczna"}
                    </span>{" "}
                    na Twojej stronie.
                </p>
            </div>

            <AppButton
                type="button"
                className="!border-on-surface border-2 bg-white rounded-full px-6 py-2 font-semibold text-on-surface hover:bg-gray-50 w-fit"
                classNameContentWrapper="gap-2"
                loaderColor='#333'
                onClick={onToggle}
            >
                <div className="flex items-center gap-2 text-base">
                    <span>{isVisible ? "Ukryj aplikację" : "Pokaż aplikację"}</span>
                    <EyeSlashIcon className="h-5 w-5"/>
                </div>
            </AppButton>
        </div>
    );
};

export default VisibilitySection;


